import { render, staticRenderFns } from "./ScoutFormEducationalBackground.vue?vue&type=template&id=72b3366a"
import script from "./ScoutFormEducationalBackground.vue?vue&type=script&lang=js"
export * from "./ScoutFormEducationalBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports